export enum CostListItemType {
  ExamType = "examType",
  TestType = "testType",
  Survey = "survey",
  ServiceType = "serviceType",
}
